/* eslint-disable global-require */
import KatalWeblab from '@amzn/katal-weblab';
import { Metrics, logger } from 'src/utils';
import WEBLAB_MAP from 'src/weblab/weblabs';
import WeblabId from 'src/weblab/weblabId';
import { MethodName, MetricName, Logs } from 'src/constants/metrics';
import WeblabTreatment from 'src/weblab/weblabTreatment';

class WeblabService {
  protected weblabClient?: KatalWeblab.KatalWeblabClient;

  protected weblabCache?: KatalWeblab.BrowserStorageCache;

  constructor() {
    if (typeof window !== 'undefined') {
      const { KatalWeblabClient, BrowserStorageCache } = require('@amzn/katal-weblab');
      const { KatalWebSellerCentralClient } = require('@amzn/katal-weblab-sellercentral');
      const cacheTTLSeconds = 604800; // 1 week
      this.weblabCache = new BrowserStorageCache('SellerForums', cacheTTLSeconds, 'cumin');
      const client = new KatalWebSellerCentralClient();
      const metricsPublisher = new Metrics('WeblabService').getActionPublisher();
      this.weblabClient = new KatalWeblabClient({
        weblabProxy: client,
        treatmentCache: this.weblabCache,
        metricsPublisher,
        cacheBehavior: {
          cacheRefreshRateSeconds: 1800, // 30 minutes
        },
      });
    }
  }

  private getTreatment(weblabId: WeblabId): string {
    const weblab = WEBLAB_MAP[weblabId];
    // @ts-ignore
    return (
      typeof window !== 'undefined'
      && this.weblabCache!.getTreatment(weblabId)?.treatmentValue
    ) || weblab.defaultTreatment;
  }

  public checkIfTreatmentEquals(
    weblabId: WeblabId,
    expectedTreatment: WeblabTreatment,
  ): boolean {
    return this.getTreatment(weblabId) === expectedTreatment;
  }

  public async fetchTreatments() {
    const weblabs = Object.values(WEBLAB_MAP);
    await this.weblabClient!.getTreatments(weblabs);
  }

  public async triggerWeblab(
    weblabId: WeblabId,
    treatmentValue: string = this.getTreatment(weblabId),
  ) {
    const metrics = new Metrics(MethodName.weblabTrigger);
    // @ts-ignore
    await this.weblabClient!.triggerWeblab(WEBLAB_MAP[weblabId], { weblabId, treatmentValue }).then(
      () => {
        metrics.publishCounterMetric(MetricName.jsError, 0);
      },
      (err) => {
        logger.error(Logs.weblabServiceFailure, { err });
        metrics.publishCounterMetric(MetricName.jsError, 1);
      },
    );
  }
}

const weblabService = new WeblabService();

export default weblabService;
